import { ApplicationGroup } from '@/models/applicationGroup';
import { UserApplicationItem } from './UserApplicationtem';
import classnames from 'classnames';
interface Props {
  groups: ApplicationGroup[];
  className?: string;
}

export const UserApplicationList: React.FC<Props> = ({ className, groups }) => {
  return (
    <div id="user-applications-list" className={classnames(className)}>
      {groups.map((group) => (
        <div
          key={group.id}
          className="mx-4 mb-4 overflow-hidden rounded-lg border border-gray-100 first:mt-4 lg:mx-8"
        >
          <h1 className="text-xl p-4 lg:px-8 lg:pt-4 lg:pb-4 font-medium">{group.title}</h1>
          <div className="grid grid-cols-4 pt-2 pb-4 lg:px-4 xl:grid-cols-5 2xl:grid-cols-6 gap-0">
            {group.applications.map((app) => (
              <UserApplicationItem key={app.id} application={app} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
